import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { AnimatePresence, motion, useMotionValueEvent, useScroll } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { navLinks } from '../data/site';
const ease = [0.23, 1, 0.32, 1] as const;
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', v => setScrolled(v > 40));
  return <header className={`fixed inset-x-0 top-0 z-50 transition-colors duration-200 ${scrolled || open ? 'border-b border-paper/10 bg-ink/95 backdrop-blur' : 'bg-transparent'}`} data-id="element-193" data-mp="ky1lc40hf4r">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:h-20 md:px-8" aria-label="Navigation principale" data-id="element-194" data-mp="9iq8pszkxgh2">
        <Link to="/" className="font-display text-2xl uppercase tracking-wide" onClick={() => setOpen(false)} data-id="element-195" data-mp="1kzgjzqiv0yhj">
          Télép<span className="text-signal" data-id="element-196" data-mp="9opv788ucf02">homme</span>
        </Link>

        <ul className="hidden items-center gap-7 lg:flex" data-id="element-197" data-mp="9qk8c0dvf2tl">
          {navLinks.map(link => <li key={link.to} data-id="element-198" data-mp="epnejo5l7f35">
              <NavLink to={link.to} end={link.to === '/'} className={({
            isActive
          }) => `whitespace-nowrap text-sm font-medium transition-colors duration-150 hover:text-paper ${isActive ? 'text-paper' : 'text-paper/60'}`} data-id="element-199" data-mp="jmx3l2p2doqg">
                {link.label}
              </NavLink>
            </li>)}
        </ul>

        <div className="flex items-center gap-3" data-id="element-200" data-mp="uutybaub8pp">
          <Link to="/contact" className="hidden whitespace-nowrap rounded-full bg-signal px-5 py-2.5 text-sm font-semibold text-paper transition-colors duration-150 hover:bg-signal-dark sm:inline-flex" data-id="element-201" data-mp="5ne7x9dfw5v1">
            Booker le groupe
          </Link>
          <button type="button" className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-paper/20 lg:hidden" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} aria-expanded={open} onClick={() => setOpen(o => !o)} data-id="element-202" data-mp="31b02wphiomup">
            {open ? <XIcon className="h-5 w-5" data-id="element-203" data-mp="3631cg3navzh1" /> : <MenuIcon className="h-5 w-5" data-id="element-204" data-mp="362rsoxsumojs" />}
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-205" data-mp="2icxheko6h81n">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease
      }} className="border-t border-paper/10 bg-ink lg:hidden" data-id="element-206" data-mp="2ddkkf73leklc">
            <ul className="flex flex-col px-5 py-4" data-id="element-207" data-mp="2ndv151ou6a59">
              {[...navLinks, {
            label: 'Contact',
            to: '/contact'
          }].map(link => <li key={link.to} data-id="element-208" data-mp="2m2nbf505kvp">
                  <NavLink to={link.to} end={link.to === '/'} onClick={() => setOpen(false)} className={({
              isActive
            }) => `block py-3 font-display text-3xl uppercase ${isActive ? 'text-signal' : 'text-paper'}`} data-id="element-209" data-mp="2krmno6ust8t">
                    {link.label}
                  </NavLink>
                </li>)}
            </ul>
          </motion.div>}
      </AnimatePresence>
    </header>;
}